if( !$('body').hasClass('knoops-gmap-init') ){
  function initMaps(){
  
    if( typeof google === 'undefined' ){
      return false;
    }

    $('.knoops-gmap' ).each( function(){
      
      var zoom = 8, center = {lat: 51.5150566, lng: -0.1020399};

      var std_silver = [
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.attraction",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi.medical",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "poi.place_of_worship",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi.school",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "poi.sports_complex",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "road",
      "stylers": [
        {
          "weight": 1
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#cbcbcb"
        },
        {
          "weight": 1
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#dadada"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#d5d5d5"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ];
      
      
      var styles = std_silver;
      
      if( typeof $(this).data('center') !== 'undefined' ){
        var $data_center = $(this).data('center');
        if( typeof $data_center.lat !== 'undefined' && typeof $data_center.lng !== 'undefined' ){
          center = $data_center;
        }
      }
      
      if( typeof $(this).data('zoom') !== 'undefined' ){
        zoom = $(this).data('zoom');
      }
      
      var map_settings = {};
      map_settings.disableDefaultUI = true;
      if( typeof $(this).data('enablezoom') !== 'undefined' && $(this).data('enablezoom') == "yes" ){	
      
      map_settings.zoomControl = true;
      }
      map_settings.center = center;
      map_settings.zoom = zoom;
      map_settings.styles = styles;
      
      var gmap = new google.maps.Map( $(this).find('.map-container')[0], map_settings); 
        
      var knoops_icon = {
        path: 'M20,0A20,20,0,0,0,0,20C0,31,14.65,52.15,20,52.15,23.87,52.15,40,31,40,20A20,20,0,0,0,20,0Zm2.64,20h-.2v8.67H20.09V11.33h2.35v7.49h.2l7.66-7.49h3.28l-8.37,8,8.94,9.33H30.72Z',
        fillColor: '#dcad71',
        scale: 1,
        fillOpacity:1,
        strokeOpacity:0,
        anchor: new google.maps.Point(20,52.15)
      };
      
      var markers = $(this).data('gmapmarkers');
      var markers_array = [];
      var bounds = new google.maps.LatLngBounds();

      var potential_icon = [];
      if( typeof $(this).data('gmapicons') !== 'undefined' ){
        potential_icon = $(this).data('gmapicons');
      }
      var potential_infoboxes = [];
      if( typeof $(this).data('gmapinfoboxes') !== 'undefined' ){
        potential_infoboxes = $(this).data('gmapinfoboxes');
      }    
      $.each( markers, function( gmap_index, gmap_marker ){
          var $marker_props = {};
          $marker_props.position = gmap_marker;
          $marker_props.map = gmap;
          if( typeof potential_icon[gmap_index] !== 'undefined' && potential_icon[gmap_index] !== 'none' ){
            if( potential_icon[gmap_index].indexOf('{') >= 0 ){
              var markertxt = document.createElement("textarea");
              markertxt.innerHTML = potential_icon[gmap_index];   
              //console.log(markertxt.value);
              $marker_props.icon = Object.assign({"anchor": new google.maps.Point(20,52.15)},JSON.parse( markertxt.value ));
              
            }else{
              $marker_props.icon = potential_icon[gmap_index];
            }
          }else{
            $marker_props.icon = knoops_icon;
          }
        
          var marker = new google.maps.Marker( $marker_props );
          
          if( typeof potential_infoboxes[gmap_index] !== 'undefined' && potential_infoboxes[gmap_index] !== 'none' ){
          
              var markertxt = document.createElement("textarea");
              markertxt.innerHTML = potential_infoboxes[gmap_index];
              var domEle = $('<div />').html(markertxt.value);
              var potInfoBox = new google.maps.InfoWindow({
                  "content": $(domEle)[0]
              });
              //console.log($(domEle)[0]);
              marker.addListener("click", function(){
                  potInfoBox.open({
                    anchor: marker,
                    gmap,
                  });
              });
          }
        
          markers_array.push( marker );
        bounds.extend( gmap_marker );
      });
      
      if( markers.length === 1 ){
        
        gmap.setCenter( markers_array[0].getPosition() );
        
        if( typeof $(this).data('infowindow') !== 'undefined' && $(this).data('infowindow') !== '' ){
          var infoWindow = new google.maps.InfoWindow({
          content: $(this).data('infowindow')
        });
          markers_array[0].addListener('click', function(){
            infoWindow.open(gmap, markers_array[0]);
          });
          
        }
        
      }else{
        
        gmap.fitBounds(bounds); 
        
        var listener = google.maps.event.addListener(gmap, "idle", function() { 
          gmap.setZoom( gmap.getZoom() - 1 ); 
          google.maps.event.removeListener(listener); 
        });

        
      }
      
      $(this).data('knoops-gmap', gmap);

    });

  }
  let script = document.createElement('script');
  script.src = "https://maps.googleapis.com/maps/api/js?key="+gmapInfo.gmapsKey+"&callback=initMaps";
  document.head.appendChild(script);
  $('body').addClass('knoops-gmap-init');
}else{
  $('document').ready(function(){
    initMaps();
  });
}